
import { Link } from "react-router-dom";

const Logo = () => {
  return (
    <Link to="/" className="flex items-center gap-2 font-bold text-lg">
      <img
        src="/lovable-uploads/4fe10da0-a97a-4ca7-a366-36844e80a3ed.png"
        alt="HelloML Logo"
        className="h-10 w-auto"
      />
      <span className="hidden sm:inline">HelloML</span>
    </Link>
  );
};

export default Logo;
